var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCardMenu = function SvgCardMenu(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 19 14",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "card")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "svg-hover",
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "svg-hover",
    id: "2.1-Home",
    transform: "translate(-35.000000, -340.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "svg-hover",
    id: "card",
    transform: "translate(32.000000, 335.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "svg-hover",
    id: "Card",
    transform: "translate(4.000000, 6.000000)",
    stroke: "var(--primaryTextColor)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.772727273,
    y: 0,
    width: 15.4545455,
    height: 11.5909091,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 3.86363636,
    x2: 17,
    y2: 3.86363636,
    id: "Path"
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCardMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/card_menu.31f04a9a.svg";
export { ForwardRef as ReactComponent };